import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Calendar.module.scss'
import { Layout, PageHeader, UnvButton, UnvModal, UnvInput, Icon } from 'components'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import moment from 'moment'
import UpcomingEvents from './components/UpcomingEvents'
import { useDispatch, useSelector } from 'react-redux'
import Notification from 'utils/Notifications'
import {
  createEvent,
  createEventForAll,
  getCompanyEvents,
  getUserEvents,
} from 'service/CalendarService'
import {
  postEvent,
  setCompanyEvents,
  setUserEvents,
} from 'store/slices/CalendarSlice'
import 'moment/locale/ru'
import 'moment/locale/ky'
import userInfo from 'utils/userInfo'
import useLoading from 'hooks/UseLoading/UseLoading'
import ButtonLoader from 'hooks/UseLoading/ButtonLoader'
const CalendarPage = () => {
  const { t, i18n } = useTranslation('common')
  const [data, setData] = useState()
  const [render, setRender] = useState()
  const [events, setEvents] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [eventColor, setEventColor] = useState('#1976d2')
  const [openModal, setOpenModal] = useState(false)
  const [privateCalendar, setPrivateCalendar] = useState(true)
  const user = userInfo()
  useEffect(() => {
    moment.locale(i18n.language)
  }, [i18n.language])
  const localizer = momentLocalizer(moment)
  const dispatch = useDispatch()
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const { loading, withLoading } = useLoading(false)

  const handleFormSubmit = async (event) => {
    event.preventDefault()
    const { title, start, end, description } = event.target.elements
    const newEvent = {
      title: title.value,
      start: new Date(start.value),
      end: new Date(end.value),
      description: description.value,
      color: eventColor,
    }
    setEvents([...events, newEvent])
    event.target.reset()
    if (privateCalendar) {
      try {
        await withLoading(async () => {
          let response = await createEvent(
            newEvent.title,
            newEvent.description,
            newEvent.color,
            newEvent.start,
            newEvent.end,
          )
          dispatch(
            postEvent({
              title: newEvent.title,
              description: newEvent.description,
              color: newEvent.color,
              start: newEvent.start,
              end: newEvent.end,
            }),
          )

          setNotify({
            isOpen: true,
            message: t('calendar.event_sent'),
            type: 'success',
            sound: 'success',
          })
          setRender(true)
          setOpenModal(false)
        })
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: 'error',
          sound: 'error',
        })
      }
    } else {
      try {
        let response = await createEventForAll(
          newEvent.title,
          newEvent.description,
          newEvent.color,
          newEvent.start,
          newEvent.end,
        )

        dispatch(
          postEvent({
            title: newEvent.title,
            description: newEvent.description,
            color: newEvent.color,
            start: newEvent.start,
            end: newEvent.end,
          }),
        )

        setNotify({
          isOpen: true,
          message: t('calendar.event_sent'),
          type: 'success',
          sound: 'success',
        })
        setRender(true)
        setOpenModal(false)
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: 'error',
          sound: 'error',
        })
      }
    }
  }

  const getData = async () => {
    if (privateCalendar) {
      try {
        let response = await getUserEvents(data)

        dispatch(
          setUserEvents({
            userCalendar: response.data,
          }),
        )
      } catch (error) {
      }
    } else {
      try {
        let response = await getCompanyEvents(data)

        dispatch(
          setCompanyEvents({
            companyCalendar: response.data,
          }),
        )
      } catch (error) {
      }
    }
  }

  useEffect(() => {
    setRender(false)
    getData()
  }, [render, privateCalendar])

  const calendar_events = useSelector((state) =>
    privateCalendar
      ? state.calendar.userCalendar
      : state.calendar.companyCalendar,
  )

  function formatCalendarEvents(events) {
    return events.map((event) => ({
      ...event,
      start: new Date(event.start),
      end: new Date(event.end),
    }))
  }

  const formattedEvents = formatCalendarEvents(calendar_events)

  const handleEventClick = (event) => {
    setSelectedEvent(event)
  }

  const handleCloseDetails = () => {
    setSelectedEvent(null)
  }

  const handleColorChange = (event) => {
    setEventColor(event.target.value)
  }

  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.color,
      color: 'black',
      borderRadius: '3px',
      border: 'none',
      display: 'block',
      padding: '6px',
      fontSize: '14px',
      height: '120',
    }

    return {
      style,
    }
  }

  return (
    <>
      <div className={styles['planner-wrapper']}>
        <PageHeader
          icon={<Icon name="calendar" size={28} />}
          title={t('calendar.page_title')}
          subtitle={t('auto.calendarpage.subtitle', 'Личные события и события компании')}
          actions={(privateCalendar || user?.is_admin_of) ? (
            <UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>
              {t('calendar.create_event')}
            </UnvButton>
          ) : null}
        />
        <div className={styles['flex']}>
      

          <div className={styles['planner-container']}>
            <Calendar
              localizer={localizer}
              events={formattedEvents}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 500 }}
              className={styles['planner-calendar']}
              onSelectEvent={handleEventClick}
              eventPropGetter={eventStyleGetter}
              allDay={t('calendar.all_day')}
              messages={{
                today: t('calendar.today'),
                previous: t('calendar.previous'),
                next: t('calendar.next'),
                month: t('calendar.month'),
                week: t('calendar.week'),
                day: t('calendar.day'),
                agenda: t('calendar.agenda'),
                allDay: t('calendar.all_day'),
              }}
            />

            {selectedEvent && (
              <div className={styles['event-details']}>
                <h2 className={styles['event-details-title']}>
                  {selectedEvent.title}
                </h2>
                <h3 className={styles['event-details-title']}>
                  {selectedEvent.employee_name}
                </h3>
                <h4 className={styles['event-details-description']}>
                  {selectedEvent.description}
                </h4>
                <p className={styles['event-details-time']}>
                  {moment(selectedEvent.start).format('LLL')} -{' '}
                  {moment(selectedEvent.end).format('LLL')}
                </p>
                <button
                  className={styles['event-details-close']}
                  onClick={handleCloseDetails}
                >
                  {t('calendar.close')}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <UnvModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={t('calendar.create_event')}
        size="md"
      >
        <form onSubmit={handleFormSubmit} id="calendar-event-form" className="unv-form">
          <div className={styles.decline_form}>
            <div className={styles.item_flex1}>
              <div className={styles.input_type3}>
                <input
                  type="text"
                  name="title"
                  required
                  className={`${styles['discription_input']} unv-input`}
                  placeholder={t('calendar.event_title')}
                />
                <textarea
                  name="description"
                  required
                  rows="3"
                  className={`${styles['discription_input']} unv-textarea`}
                  placeholder={t('calendar.description')}
                  maxLength={2000}
                />

                <div className={styles.report_dates_wrapper}>
                  <div className={styles.date_for_report}>
                    <h4>{t('calendar.from')}</h4>
                    <input
                      type="datetime-local"
                      name="start"
                      required
                      className={`${styles['discription_input']} unv-input`}
                    />
                  </div>
                  <div className={styles.date_for_report}>
                    <h4>{t('calendar.to')}</h4>
                    <input
                      type="datetime-local"
                      name="end"
                      required
                      className={`${styles['discription_input']} unv-input`}
                    />
                  </div>
                </div>
                <input
                  type="color"
                  id="color"
                  style={{ margin: '0 auto', width: '100%' }}
                  value={eventColor}
                  onChange={handleColorChange}
                  list="reds"
                />

                <datalist id="reds">
                  <option>#2BC760</option>
                  <option>#cc5f05</option>
                  <option>#DE3737</option>
                  <option>#37D4DE</option>
                  <option>#EABFFF</option>
                </datalist>
              </div>
            </div>
          </div>
        </form>
        <UnvModal.Footer>
          <UnvButton variant="ghost" onClick={() => setOpenModal(false)}>{t('calendar.close')}</UnvButton>
          <UnvButton variant="primary" iconLeft="plus" type="submit" form="calendar-event-form" loading={loading}>
            {t('calendar.create')}
          </UnvButton>
        </UnvModal.Footer>
      </UnvModal>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  )
}

export default CalendarPage
